import {Route,Switch,BrowserRouter } from "react-router-dom";

import CouponsTable from "components/Doobi/Coupons";
import DoobiHeader from "components/Headers/DoobiHeader";
import DiscountTable from "components/Doobi/Discounts";

const CouponsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Coupons" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/discount-types`} component={DiscountTable}/>
      <Route path={`${match.path}/`} component={CouponsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default CouponsRoute;
